import { render, staticRenderFns } from "./DxChain.vue?vue&type=template&id=ba599106&scoped=true"
import script from "./DxChain.vue?vue&type=script&lang=js"
export * from "./DxChain.vue?vue&type=script&lang=js"
import style0 from "./DxChain.vue?vue&type=style&index=0&id=ba599106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba599106",
  null
  
)

export default component.exports